/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Reassign_Notice_DismissInputs */

const en_ticket_reassign_notice_dismiss = /** @type {(inputs: Ticket_Reassign_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const ja_ticket_reassign_notice_dismiss = /** @type {(inputs: Ticket_Reassign_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

const fr_ticket_reassign_notice_dismiss = /** @type {(inputs: Ticket_Reassign_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_ticket_reassign_notice_dismiss = /** @type {(inputs: Ticket_Reassign_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Ticket_Reassign_Notice_DismissInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_reassign_notice_dismiss = /** @type {((inputs?: Ticket_Reassign_Notice_DismissInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Reassign_Notice_DismissInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_reassign_notice_dismiss(inputs)
	if (locale === "ja") return ja_ticket_reassign_notice_dismiss(inputs)
	if (locale === "fr") return fr_ticket_reassign_notice_dismiss(inputs)
	return de_ticket_reassign_notice_dismiss(inputs)
});